import { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { api } from '../lib/api';
import { PhoneFrame, PhonePicker, usePhone } from '../components/n4/PhoneFrame';
import { applyPalette } from '../components/n4/DesignerPanel';

// Önálló, keret nélküli lap a Mobil nézethez — a Tervező és a Design sablonok „Új lapon” gombja nyitja mobil nézetben:
// a telefon-keret alapból 1:1-ben (a felirat-sor gombjával a képernyőhöz illeszthető), a telefon itt is váltható.
// ?project=&design= — a Tervező egy design-mintája (#swap= a még nem mentett színcsere, JSON); ?src= — élő oldal (sablon minta-oldala); ?title= felirat.
export function PhonePage() {
  const [params] = useSearchParams(); const { hash } = useLocation(); // a hash is függőség: ha csak az változik, újra kell tölteni
  const ph = usePhone();
  const project = params.get('project'); const designId = params.get('design'); const src = params.get('src') || undefined;
  const [title, setTitle] = useState(params.get('title') || '');
  const [html, setHtml] = useState<string | null>(null);
  const [err, setErr] = useState('');
  useEffect(() => {
    if (!project || !designId) { if (!src) setErr('Nincs mit mutatni: hiányzik a design azonosítója vagy a cím.'); return; }
    let swap: Record<string, string> = {};
    try { const h = new URLSearchParams(hash.slice(1)).get('swap'); if (h) swap = JSON.parse(h) as Record<string, string>; } catch { /* rossz hash: színcsere nélkül */ }
    api<{ design: { title: string; content: string } }>(`/api/n4/projects/${project}/designs/${designId}`)
      .then((r) => { setTitle(r.design.title); setHtml(applyPalette(r.design.content, swap)); })
      .catch((e) => setErr(e instanceof Error ? e.message : 'Nem sikerült betölteni.'));
  }, [project, designId, src, hash]);
  useEffect(() => { document.title = `${title || 'Mobil nézet'} · ${ph.phone.name}`; }, [title, ph.phone.name]);
  const ready = Boolean(src) || html != null;
  return (
    <div className="a-phonepage">
      <div className="bar">
        <b title={title}>{title || 'Mobil nézet'}</b>
        <PhonePicker {...ph} />
        <span className="hint">alapból 1:1 — a felirat-sor gombjával a képernyőhöz illeszthető</span>
      </div>
      {err && <p className="err">{err}</p>}
      {ready && <PhoneFrame phone={ph.phone} land={ph.land} title={title || 'mobil'} src={src} srcDoc={html ?? undefined} sandbox={html != null ? 'allow-scripts allow-forms allow-modals allow-popups' : undefined} defaultFit={false} />}
    </div>
  );
}
